import React, { lazy, Suspense } from "react";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";

// Below-the-fold components load as separate chunks so the main bundle stays small.
const Origen = lazy(() =>
  import("@/components/Origen").then((m) => ({ default: m.Origen }))
);
const Products = lazy(() =>
  import("@/components/Products").then((m) => ({ default: m.Products }))
);
const Ritual = lazy(() =>
  import("@/components/Ritual").then((m) => ({ default: m.Ritual }))
);
const Testimonials = lazy(() =>
  import("@/components/Testimonials").then((m) => ({ default: m.Testimonials }))
);
const Faq = lazy(() =>
  import("@/components/Faq").then((m) => ({ default: m.Faq }))
);
const Footer = lazy(() =>
  import("@/components/Footer").then((m) => ({ default: m.Footer }))
);
const CartSheet = lazy(() =>
  import("@/components/CartSheet").then((m) => ({ default: m.CartSheet }))
);

// Min-height placeholders prevent layout shift while chunks load.
const Placeholder = ({ h }) => <div style={{ minHeight: h }} />;

export default function HomePage() {
  return (
    <div data-testid="homepage" className="bg-[#1A1322] min-h-screen">
      <Header />
      <main>
        <Hero />
        {/* CRO order: producto convierte primero, luego ritual reduce dudas,
            origen aporta storytelling, y prueba social + FAQ antes del cierre. */}
        <Suspense fallback={<Placeholder h="800px" />}>
          <Products />
        </Suspense>
        <Suspense fallback={<Placeholder h="500px" />}>
          <Ritual />
        </Suspense>
        <Suspense fallback={<Placeholder h="600px" />}>
          <Origen />
        </Suspense>
        <Suspense fallback={<Placeholder h="500px" />}>
          <Testimonials />
        </Suspense>
        <Suspense fallback={<Placeholder h="500px" />}>
          <Faq />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      <Suspense fallback={null}>
        <CartSheet />
      </Suspense>
      <StickyMobileCTA />
    </div>
  );
}
